import React from 'react';
import Seo from '../components/Seo';
import Base64Tool from '../components/Base64Tool';
import FaqSection from '../components/Faq';
import { FeaturesGrid, WhatIsBase64, UseCases, PageHero, MoreTools } from '../components/InfoSections';
import { softwareApplicationSchema, faqPageSchema, Faq } from '../lib/schema';

const FAQS: Faq[] = [
  { q: 'What is a Base64 encoder and decoder?', a: 'A Base64 encoder converts text or binary data into a Base64 string using a 64-character alphabet, while a decoder converts a Base64 string back into its original text. EasyBase64 does both instantly in your browser.' },
  { q: 'Is this Base64 converter free to use?', a: 'Yes. EasyBase64 is completely free, with no registration, no limits and no ads getting in the way of the tool.' },
  { q: 'Is my data safe when I encode or decode here?', a: 'Yes. All encoding and decoding happens locally in your browser using JavaScript. Your text is never uploaded to a server.' },
  { q: 'Does Base64 encrypt my data?', a: 'No. Base64 is an encoding, not encryption. Anyone can decode a Base64 string, so never use it to protect passwords or sensitive information.' },
  { q: 'Can I encode emoji and non-English characters?', a: 'Yes. The converter is fully UTF-8 aware, so emoji, accented letters and non-Latin scripts encode and decode correctly.' },
];

export default function Home() {
  return (
    <>
      <Seo
        title="EasyBase64 — Free Online Base64 Encoder & Decoder"
        description="Free online Base64 encoder and decoder. Convert text to Base64 and decode Base64 to text instantly in your browser. UTF-8 safe, private and fast — no signup."
        path="/"
        jsonLd={[
          softwareApplicationSchema({
            name: 'EasyBase64 Converter',
            description: 'Free online Base64 encoder and decoder that converts text to Base64 and back instantly in the browser.',
            path: '/',
          }),
          faqPageSchema(FAQS),
        ]}
      />

      <PageHero
        title="Base64 Encoder & Decoder"
        subtitle={<>Convert text to Base64 and decode Base64 back to text instantly. <strong>Fast, UTF-8 safe and 100% private</strong> — everything runs in your browser.</>}
      />

      <div className="mb-12">
        <Base64Tool initialMode="encode" variant="standard" />
      </div>

      <div className="mb-12">
        <FeaturesGrid />
      </div>

      <div className="grid lg:grid-cols-2 gap-8 mb-12">
        <WhatIsBase64 />
        <UseCases />
      </div>

      <div className="mb-12">
        <MoreTools />
      </div>

      <FaqSection title="Frequently asked questions" faqs={FAQS} />
    </>
  );
}
